import { render, staticRenderFns } from "./CV-Short.vue?vue&type=template&id=52352a8a&scoped=true&"
import script from "./CV-Short.vue?vue&type=script&lang=js&"
export * from "./CV-Short.vue?vue&type=script&lang=js&"
import style0 from "./CV-Short.vue?vue&type=style&index=0&id=52352a8a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "52352a8a",
  null
  
)

export default component.exports